import * as actionTypes from './actionTypes';

// NIGHT MODE
export const setNightMode = nightMode => {
    return {
        type: actionTypes.SET_NIGHT_MODE,
        nightMode
    }
}
